exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-slider-horizontal { width: 100%; padding: 0px; }\n.pre-treat-cost label { margin-right: 1rem; }\n.mat-slider-horizontal .mat-slider-wrapper {\n\tleft: 0;\n\tright: 0;\n}\n.mat-flat-button.mat-primary {\n\tcolor: #333 !important;\n    background-color: #FFCE47 !important;\n}\n.mat-flat-button.mat-primary:hover {\n    color: #fff !important;\n    background: #333 !important;\n}\n.mat-flat-button.mat-primary:focus {\n    color: #333 !important;\n    background-color: #FFCE47 !important;\n}\n.add-color-btn {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/print-specs/print-specs.component.css
// module id = ../../../../../src/app/mnt-invoices/print-specs/print-specs.component.css
// module chunks = common